import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { GetAndCreateAssignedToMails } from '../../../../services/ProductService/AddProducts/AddProducts';

export default function AssignedToModal({ onAssign, AssignedData }) {
    const [assignedEmail, setAssignedEmail] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [showSuggestions, setShowSuggestions] = useState(false);
    const [value, setValue] = useState('Not Assigned');
    const [message, setMessage] = useState('');

    const [product_assign, setAssignment] = useState({
        admin_emails: [],
        completed_on: '',
        priority: '',
        comments: '',
    });

    const openPopup = () => setShowPopup(true);
    const closePopup = () => setShowPopup(false);

    // Fetch emails
    const fetchAssignedEmails = async () => {
        try {
            const response = await GetAndCreateAssignedToMails('GET', {});
            setAssignedEmail(response.data);
        } catch (error) {
            console.error('Error fetching emails:', error);
        }
    };

    // Handle selecting an email
    const handleSelectEmail = (email) => {
        if (!product_assign.admin_emails.includes(email)) {
            setAssignment((prev) => ({
                ...prev,
                admin_emails: [...prev.admin_emails, email],
            }));
        }      
        setInputValue('');
        setShowSuggestions(false);
    };

    // Handle removing an email
    const handleRemoveEmail = (email) => {
        setAssignment((prev) => ({
            ...prev,
            admin_emails: prev.admin_emails.filter((item) => item !== email),
        }));
    };

    // Handle input changes
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        setShowSuggestions(true);
    };

    // Show suggestions on focus
    const handleInputFocus = () => {
        setShowSuggestions(true);
    };

    // Close suggestions when clicking outside
    const handleClickOutside = (e) => {
        if (!e.target.closest('.suggestion-container')) {
            setShowSuggestions(false);
        }
    };

    const handleAssign = () => {
        const { admin_emails, completed_on, priority, comments } = product_assign;
    
        // Validation check (excluding assigned_to_me)
        if (
            admin_emails.length === 0 || // At least one email is required
            !completed_on ||             // Completed date is required
            !priority ||                 // Priority is required
            !comments                    // Comments are required
        ) {
            setMessage('Please fill in all fields before assigning.');
            return;
        }  
        // Ensure product_assign is passed as an object, not a string
        onAssign(product_assign );
    
        closePopup();
        setValue('Assigned');
        setMessage('');
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        fetchAssignedEmails();
    }, []);
    
    useEffect(() => {
        if (AssignedData) {
            console.log(AssignedData);
    
            // Update the assignment state
            setAssignment((prev) => ({ ...prev, ...AssignedData }));
    
            // Check if at least one required field is filled
            if (
                AssignedData.admin_emails.length > 0 ||
                AssignedData.completed_on.trim() !== "" ||
                AssignedData.priority.trim() !== "" ||
                AssignedData.comments.trim() !== ""
            ) {
                setValue('Assigned'); // Set the value to 'Assigned'
            }
        }
    }, [AssignedData]);        

    return (
        <div>
            {/* Trigger to open modal */}
            <div className="flex flex-col">
                <label htmlFor="assignedTo" className="font-semibold text-[#667085]">
                    Assigned To <span className="text-red-500">*</span>
                </label>
                <input
                    value={value}
                    onClick={openPopup}
                    name='Assignedto'
                    required
                    className={`mt-2 p-2 border border-gray-300 rounded-md outline-none cursor-pointer ${value === 'Assigned' ? 'text-green-500' : 'text-red-600'}`}
                    readOnly
                />
            </div>

            {/* Popup */}
            <Modal
                isOpen={showPopup}
                onRequestClose={closePopup}
                className="bg-white p-6 rounded-lg shadow-lg w-fit mx-auto z-50  font-normal"
                overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
            >
                {/* Header */}
                <div className="border-b border-gray-400 mb-4">
                    <h2 className="text-xl font-semibold text-center">Assigned To</h2>
                </div>

                {/* Assigned to me checkbox */}
                <div className="flex items-center gap-3 mb-4">
                    <input
                        type="checkbox"
                        name="assigned_to_me"
                        checked={product_assign.assigned_to_me === true}
                        onChange={(e) =>
                            setAssignment((prev) => ({
                                ...prev,
                                assigned_to_me: e.target.checked,
                            }))
                        }
                        className="scale-125"
                    />
                    <p>Assigned To me</p>
                </div>

                {/* Assign to */}
                <div>
                    <h1 className="text-gray-500 font-bold mb-2">
                        Assign To <span className="text-red-500">*</span>
                    </h1>
                    <div className="relative suggestion-container">
                        {/* Input with selected emails */}
                        <div className="flex items-center gap-2 border border-gray-300 rounded-md bg-blue-50 p-2 h-20 overflow-y-scroll whitespace-nowrap">
                            {product_assign.admin_emails.map((email) => (
                                <div
                                    key={email}
                                    className="bg-blue-100 text-blue-700 px-2 py-1 rounded flex items-center"
                                >
                                    {email}
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveEmail(email)}
                                        className="ml-2 text-red-500 hover:text-red-700"
                                    >
                                        ✕
                                    </button>
                                </div>
                            ))}
                            <input
                                type="text"
                                value={inputValue}
                                onChange={handleInputChange}
                                onFocus={handleInputFocus}
                                placeholder="Enter assigned to"
                                className="outline-none bg-blue-50 flex-shrink-0 w-40"
                            />
                        </div>

                        {/* Suggestions */}
                        {showSuggestions && (
                            <div className="absolute z-10 bg-white border border-gray-300 w-full mt-1 rounded-md shadow-md max-h-40 overflow-y-auto">
                                {assignedEmail
                                    .filter((item) =>
                                        item.a_email.toLowerCase().includes(inputValue.toLowerCase())
                                    )
                                    .map((item) => (
                                        <div
                                            key={item.id}
                                            onClick={() => handleSelectEmail(item.a_email)}
                                            className="p-2 cursor-pointer hover:bg-blue-100"
                                        >
                                            {item.a_email}
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Completed By & Priority */}
                <div className="flex justify-between items-center gap-5">
                    <div>
                        <h1 className="font-semibold mb-2 text-gray-500">Completed By</h1>
                        <input
                            type="date"
                            name="completed_on"
                            required
                            value={product_assign.completed_on}        
                            onChange={(e) =>
                                setAssignment((prev) => ({
                                    ...prev,
                                    completed_on: e.target.value,
                                }))
                            }
                            className="w-52 border border-gray-300 rounded-xl p-3 bg-blue-50 outline-none"
                        />
                    </div>
                    <div>
                        <h1 className="font-semibold mb-2 text-gray-500">Priority</h1>
                        <select
                            name="priority"
                            required
                            value={product_assign.priority.charAt(0).toUpperCase() + product_assign.priority.slice(1)}
                            onChange={(e) =>
                                setAssignment((prev) => ({
                                    ...prev,
                                    priority: e.target.value,
                                }))
                            }
                            className="w-52 p-4 border border-gray-300 rounded-xl outline-none bg-blue-50 cursor-pointer"
                        >
                            <option value="">Select Priority</option>
                            <option value="Low" className="text-orange-600">Low</option>
                            <option value="Medium" className="text-green-600">Medium</option>
                            <option value="High" className="text-[#FF0000]">High</option>
                        </select>
                    </div>
                </div>

                {/* Comments */}
                <div>
                    <h1 className="font-bold text-gray-500">Comments</h1>
                    <textarea
                        name="comments"
                        required
                        value={product_assign.comments}
                        onChange={(e) =>
                            setAssignment((prev) => ({
                                ...prev,
                                comments: e.target.value,
                            }))
                        }
                        placeholder="Write Comments..."
                        className="border border-gray-300 h-32 w-full my-2 rounded-xl bg-blue-50 p-2 outline-none"
                    />
                </div>

                <div>
                    <p className='text-[#FF0000]'>{message}</p>
                </div>

                {/* Action Buttons */}
                <div className="flex justify-end space-x-3 mt-4">
                    <button onClick={closePopup} className="px-4 py-2 border">
                        Cancel
                    </button>
                    <button onClick={handleAssign} className="px-4 py-2 bg-blue-500 text-white">
                        Assign
                    </button>
                </div>
            </Modal>
        </div>
    );
}